package er.prateek.crossly.game.crossword

/**
 * How many letter keys the player is offered.
 *
 * The full keyboard is the crossword tradition; the two narrower modes turn the
 * bottom of the screen into a small tile rack, which is what makes a phone-sized
 * grid feel like a game rather than a form to type into.
 */
enum class KeyboardMode {
    /** All 26 keys, QWERTY. */
    FULL,

    /** Only the letters still missing somewhere in the grid. Shrinks as you solve. */
    RELEVANT,

    /** Only the letters of the word under the cursor, plus a couple of decoys. */
    WORD,

    /**
     * Every distinct letter that appears anywhere in this puzzle's solution -- unlike
     * [RELEVANT], the rack never shrinks: a letter stays offered even after every one of its
     * occurrences is filled in.
     */
    THIS_PUZZLE,
}

/** How much of the grid is already filled in when a puzzle opens. */
enum class StarterAmount(val fraction: Float) {
    NONE(0f),
    FEW(0.15f),
    MANY(0.3f),
}
